import i18n from "i18next";
import {
  ShieldCheckIcon,
  ShieldExclamationIcon,
  TagIcon,
} from "@heroicons/react/24/outline";
export function getManagementMenus(hasPermission) {
  return [
    {
      label: "Aperçu",
      link: "/management-dashboard",
    },
    hasPermission("management.news.manage") && {
      label: "Actualités",
      link: "/admin-news-validation-list",
      icon: ShieldCheckIcon,
    },
    hasPermission("management.ticketing.manage") && {
      label: i18n.t("menu.ticketing"),
      icon: TagIcon,
      subMenus: [
        {
          label: i18n.t("menu.createTicketing"),
          link: "/ticketing/create",
          icon: TagIcon,
        },
        {
          label: i18n.t("menu.ticketing"),
          link: "/ticketings",
          icon: TagIcon,
        },
        {
          label: i18n.t("ticketing.ticketsValidation"),
          link: "/admin-tickets-validation",
          icon: TagIcon,
        },
      ],
    },
    hasPermission("admin.permissions.manage") && {
      label: "Gestion des permissions",
      link: "/admin/management/permissions",
      icon: ShieldExclamationIcon,
    },
  ].filter(Boolean);
}
